const GROUPE_LOCUTEURS = {
    'Québec / Canada': ['HÉLÈNE', 'PIERRE'],
    'France / Europe': ['JOSETTE', 'ROBERT']
};

const TEMPLATE = document.createElement('template');
TEMPLATE.innerHTML = `
<!-- Police d'icônes Usito injectée dans le shadow root : le CSS global ne le
     pénètre pas, donc on importe ici les classes .icon / i-* pour les réutiliser. -->
<link rel="stylesheet" href="/css/font-usito/style.css">
<style>
    :host {
        --primary-color: #4a4a4a;
        --text-color: #4a4a4a;
        --vert-clair: #018849;
        --vert-foncé: #11594b;
        --bg-color: #fff;
        --border-radius: 8px;
        font-family: "Roboto", Arial, sans-serif;
    }

    a, a:active, a:visited {
      color: var(--vert-clair);
      text-decoration: underline;
    }
    a i, a:active i, a:visited i {
      color: var(--vert-foncé);
    }
    
    a:hover {
      color: #11594b;
      text-decoration: none;
    }


    dialog {
        padding: 0;
        border: none;
        border-radius: var(--border-radius);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        max-width: 90vw;
        width: 400px;
        color: var(--text-color);
    }
    
    dialog::backdrop {
        background: rgba(0, 0, 0, 0.5);
    }

    .modal-header {
        background: #f8f9fa;
        padding: 1rem;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .vedette {
        font-size: 1.25rem;
        font-weight: bold;
        margin: 0;
        color: var(--primary-color);
    }

    .close-btn {
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        line-height: 1;
        padding: 0 0.5rem;
        color: #666;
    }

    /* Pas de cadre noir à l'ouverture (focus programmatique / souris)… */
    dialog:focus,
    .close-btn:focus {
        outline: none;
    }

    /* …mais on conserve un anneau de focus net pour la navigation clavier. */
    .close-btn:focus-visible {
        outline: 2px solid var(--vert-clair);
        outline-offset: 2px;
        border-radius: 3px;
    }

    .modal-body {
        padding: 1rem;
        max-height: 60vh;
        overflow-y: auto;
    }
    
    .modal-texte {
       padding: 1rem;
       font-size: 1.15rem;
       line-height: 1.5;
    }
    
    figcaption {
        text-align: right;
    }

    .locuteur-group {
        margin-bottom: 1.5rem;
    }

    .group-title {
        font-size: 0.85rem;
        text-transform: uppercase;
        color: #888;
        border-bottom: 2px solid #eee;
        padding-bottom: 0.25rem;
        margin-bottom: 0.75rem;
    }

    .audio-list {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .audio-item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        width: 100%;
        padding: 0.5rem;
        border: none;
        background: none;
        border-radius: 6px;
        font: inherit;
        color: inherit;
        text-align: left;
        cursor: pointer;
        transition: background 0.2s;
    }

    .audio-item:hover {
        background: rgba(1, 136, 73, 0.06);
    }

    .audio-item.lecture-en-cours {
        background: rgba(1, 136, 73, 0.12);
    }

    .audio-item:focus { outline: none; }
    .audio-item:focus-visible {
        outline: 2px solid var(--vert-clair);
        outline-offset: -2px;
    }

    .play-btn {
        background: var(--primary-color);
        color: white;
        border: none;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        flex-shrink: 0;
    }

    .play-btn:hover {
        opacity: 0.9;
    }

    .play-btn svg {
        width: 16px;
        height: 16px;
        fill: currentColor;
    }

    .transcription {
        font-family: "Doulos SIL", "Charis SIL", serif;
        font-size: 1.1rem;
        color: #777;
        margin-left: 0.25rem;
    }
    
    .locuteur-name {
        font-size: 0.8rem;
        color: #666;
        /*margin-left: auto;*/
    }
</style>

<dialog id="audioDialog">
    <div class="modal-header">
        <h2 class="vedette" id="titre"></h2>
        <button type="button" class="close-btn" aria-label="Fermer"><i class="icon i-fermer" aria-hidden="true"></i></button>
    </div>
    <div class="modal-texte" id="texte">
    
    </div>
    <div class="modal-body" id="modalBody">
    </div>
</dialog>
`;

export class UsitoAudioModal extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(TEMPLATE.content.cloneNode(true));

        this.dialog = this.shadowRoot.getElementById('audioDialog');
        this.bodyContainer = this.shadowRoot.getElementById('modalBody');
        this.titre = this.shadowRoot.getElementById('titre');
        this.texte = this.shadowRoot.getElementById('texte');

        this.currentAudio = null; // Singleton pour l'instance audio en cours
        this.activeBtn = null;    // Bouton visuellement actif
        this.afficheTranscription = false; // pref globale (posée par le contrôleur avant ouverture)
    }

    connectedCallback() {
        // Gestion de la fermeture
        this.shadowRoot.querySelector('.close-btn').addEventListener('click', () => this.close());
        this.dialog.addEventListener('close', () => this.stopAudio());

        // Clic sur le backdrop pour fermer
        this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
        });
    }

    /**
     * Point d'entrée principal
     * @param {string} atomeId - L'ID API
     * @param {string} titre - Le texte à afficher en titre
     * @param {string} texteHTML - innerHTML du texte qui sera réalisé (prononcé)
     * @param {string} apiBaseUrl - URL de l'API (ex: /v2)
     */
    async open(atomeId, titre, texteHTML, apiBaseUrl) {
        return this.openDepuisUrl(`${apiBaseUrl}/audio/${atomeId}`, titre, texteHTML, atomeId);
    }

    /**
     * Variante : ouvre la modale en récupérant les métadonnées depuis une URL complète.
     * Utile quand l'atomeId n'est pas connu côté client (ex: résolution lexieId →
     * forme-lemme via /v2/audio/lexie/{lexieId}/lemme).
     * @param {string} metaUrl   URL des métadonnées de locuteurs
     * @param {string} titre     texte affiché en titre
     * @param {string} texteHTML innerHTML du texte réalisé (prononcé)
     * @param {string} idPourLog identifiant utilisé pour la télémétrie (atomeId ou lexieId)
     */
    async openDepuisUrl(metaUrl, titre, texteHTML, idPourLog) {
        this.atomeId = idPourLog;
        this.titre.textContent = 'Écouter';
        this.texte.innerHTML = texteHTML || '';
        this.bodyContainer.innerHTML = ''; // Reset

        // Support Dialog Polyfill
        if (!this.dialog.showModal) {
            dialogPolyfill.registerDialog(this.dialog);
        }

        this.dialog.showModal();

        try {
            // Appel API
            const response = await fetch(metaUrl);
            if (!response.ok) throw new Error('Audio introuvable');

            const data = await response.json();
            this.render(data);
        } catch (e) {
            this.bodyContainer.innerHTML = `<p style="color:red; text-align:center;">Aucune prononciation disponible.</p>`;
            console.error(e);
        }
    }

    close() {
        this.stopAudio();
        this.dialog.close();
        // Auto-nettoyage du DOM après fermeture
        this.remove();
    }

    render(data) {
        let hasContent = false;

        // Itération sur les groupes définis (Q/C, F/E)
        for (const [groupeNom, locuteursCodes] of Object.entries(GROUPE_LOCUTEURS)) {

            // Filtrer les locuteurs présents dans la réponse API
            const locuteursDuGroupe = locuteursCodes
                .map(code => data[code]) // data["PIERRE"] -> LocuteurDto
                .filter(Boolean); // Garde seulement ceux qui existent

            if (locuteursDuGroupe.length > 0) {
                hasContent = true;
                const groupDiv = document.createElement('div');
                groupDiv.className = 'locuteur-group';

                groupDiv.innerHTML = `<div class="group-title">${groupeNom}</div>`;
                const listDiv = document.createElement('div');
                listDiv.className = 'audio-list';

                locuteursDuGroupe.forEach(locuteur => {
                    locuteur.réalisations.forEach(realisation => {
                        listDiv.appendChild(this.createAudioRow(locuteur, realisation));
                    });
                });

                groupDiv.appendChild(listDiv);
                this.bodyContainer.appendChild(groupDiv);
            }
        }

        if (!hasContent) {
            this.bodyContainer.innerHTML = `<p>Aucun enregistrement disponible pour cet atome.</p>`;
            return;
        }

        // Place le focus sur la première ligne d'écoute (et non sur le bouton
        // fermer « auto-focusé » par showModal()
        const premièreLigne = this.bodyContainer.querySelector('.audio-item');
        if (premièreLigne) premièreLigne.focus();
    }

    createAudioRow(locuteur, realisation) {
        // La LIGNE entière est le bouton (grande cible, accessible au clavier).
        // Le cercle play n'est qu'un indicateur visuel (un <span>, pas de bouton imbriqué).
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'audio-item';
        row.setAttribute('aria-label', `Écouter ${locuteur.nom}`);
        row.setAttribute('aria-pressed', 'false');

        const icone = document.createElement('span');
        icone.className = 'play-btn';
        icone.setAttribute('aria-hidden', 'true');
        icone.innerHTML = this.getPlayIcon();

        row.onclick = () => this.toggleAudio(realisation.audioUrl, icone, locuteur, realisation);

        row.appendChild(icone);
        row.insertAdjacentHTML('beforeend', `<span class="locuteur-name">${locuteur.nom}</span>`);

        // Transcription phonétique : seulement si disponible ET si la préférence globale
        // est activée (masquée par défaut, peu de gens lisent l'API).
        const transcription = (realisation.transcription || '').trim();
        if (transcription && this.afficheTranscription) {
            row.insertAdjacentHTML('beforeend', `<span class="transcription">[ ${transcription} ]</span>`);
        }

        return row;
    }

    toggleAudio(url, btn, locuteur, realisation) {
        // Cas 1 : On clique sur le bouton déjà en train de jouer (Pause)
        if (this.currentAudio && this.activeBtn === btn && !this.currentAudio.paused) {
            this.currentAudio.pause();
            this._setÉtatLecture(btn, false);
            return;
        }

        // Cas 2 : On clique sur le bouton en pause (Reprise)
        if (this.currentAudio && this.activeBtn === btn && this.currentAudio.paused) {
            // On change l'icône tout de suite (UI optimiste)
            this._setÉtatLecture(btn, true);

            this.currentAudio.play()
                .catch(error => {
                    console.warn("La reprise de la lecture a été interrompue ou empêchée :", error);
                    // En cas d'erreur (ex: clic rapide pause), on remet l'icône Play
                    this._setÉtatLecture(btn, false);
                });
            return;
        }

        // Cas 3 : Nouveau son (Stop everything & Play new)
        this.stopAudio();

        // Analytics Hook
        envoyerÉvénementGTM('clics', 'lecture_audio', `${this.atomeId} | ${locuteur.idLocuteur} | ${realisation.transcription}`);

        this.currentAudio = new Audio(url);
        this.activeBtn = btn;

        this.currentAudio.addEventListener('ended', () => {
            this._setÉtatLecture(btn, false);
            this.activeBtn = null;
        });

        // Gestion d'erreur de chargement (ex: 404, format non supporté)
        this.currentAudio.addEventListener('error', () => {
            this._setÉtatLecture(btn, false);
            console.error("Erreur de chargement du fichier audio");
        });

        // L'état (icône ❚❚/►, aria-pressed, surbrillance) suit l'audio RÉEL : fiable
        // même quand la génération TTS d'un texte long retarde le démarrage de la lecture.
        this.currentAudio.addEventListener('playing', () => this._setÉtatLecture(btn, true));
        this.currentAudio.addEventListener('pause',   () => this._setÉtatLecture(btn, false));

        // Lecture du nouveau son avec gestion de la Promise
        this._setÉtatLecture(btn, true); // UI Optimiste

        this.currentAudio.play()
            .catch(error => {
                // AbortError = lecture interrompue (génération TTS lente, ou clic suivant) :
                // bénin. On NE touche PAS à l'état (activeBtn, icône) — sinon le suivi
                // play/pause se désynchronise et tout re-clic redémarre. Les vraies erreurs
                // de chargement sont gérées par l'événement 'error'.
                if (error.name !== 'AbortError') {
                    console.error("Erreur lors de la tentative de lecture :", error);
                }
            });
    }

    stopAudio() {
        if (this.currentAudio) {
            this.currentAudio.pause();
            this.currentAudio = null;
        }
        if (this.activeBtn) {
            this._setÉtatLecture(this.activeBtn, false);
            this.activeBtn = null;
        }
    }

    // Met à jour l'icône (►/❚❚) ET l'état accessible (aria-pressed) de la ligne.
    _setÉtatLecture(span, joue) {
        span.innerHTML = joue ? this.getPauseIcon() : this.getPlayIcon();
        const row = span.closest('.audio-item');
        if (row) {
            row.setAttribute('aria-pressed', joue ? 'true' : 'false');
            row.classList.toggle('lecture-en-cours', joue); // « qui joue » visible, indépendant du focus
        }
    }

    getPlayIcon() {
        return `<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>`;
    }

    getPauseIcon() {
        return `<svg viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>`;
    }
}

// Garde : ce composant est importé par plusieurs entry points (usito-paquet.js
// global ET usito-mots.js), bundlés séparément ; on évite un double define.
if (!customElements.get('usito-audio-modal')) {
    customElements.define('usito-audio-modal', UsitoAudioModal);
}
